const WHATSAPP_NUMBER = '16892317017';

interface LeadData {
  name: string;
  email: string;
  phone?: string;
  nationality?: string;
  programInterest?: string;
  subject?: string;
  message?: string;
  source: 'lead_capture' | 'contact_page';
}

export function buildWhatsAppUrl(data: LeadData): string {
  const sourceLabel = data.source === 'contact_page' ? 'Contact Page' : 'Lead Capture Form';
  let text = `📋 *New Inquiry — ${sourceLabel}*\n\n`;
  text += `👤 *Name:* ${data.name}\n`;
  text += `📧 *Email:* ${data.email}\n`;
  if (data.phone) text += `📱 *Phone:* ${data.phone}\n`;
  if (data.nationality) text += `🌍 *Nationality:* ${data.nationality}\n`;
  if (data.programInterest) text += `🎓 *Program Interest:* ${data.programInterest}\n`;
  if (data.subject) text += `📌 *Subject:* ${data.subject}\n`;
  if (data.message) text += `\n💬 *Message:*\n${data.message}`;

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
}

/**
 * Open WhatsApp with the lead data. MUST be called synchronously inside a
 * user-gesture event handler (e.g. on click/submit) BEFORE any `await`,
 * otherwise browsers block the popup.
 *
 * Uses an <a target="_blank"> click as a more reliable alternative to
 * window.open() — it also avoids most popup blockers and works on iOS Safari.
 */
export function sendWhatsAppNotification(data: LeadData): void {
  const url = buildWhatsAppUrl(data);
  // Try a synchronous anchor click first (best for popup blockers within
  // user-gesture handlers). If that fails, escape the (possibly sandboxed)
  // preview iframe by navigating window.top, then fall back to same-tab.
  try {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  } catch (err) {
    console.warn('WhatsApp anchor open failed, falling back', err);
  }
  try {
    const w = window.open(url, '_blank', 'noopener,noreferrer');
    if (w) return;
  } catch {
    /* ignore */
  }
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = url;
      return;
    }
  } catch {
    /* cross-origin top — fall through */
  }
  window.location.href = url;
}
